import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { usePatientAppointments } from '@/hooks/use-patient-appointments.js';

import { sectionHeading } from '@/styles/sectionHeading.ts';

import { AppointmentSummaryCard } from './appointment-summary-card.tsx';

const MAX_CARDS = 3;
const MIN_CARD_WIDTH = '20rem';

const useStyles = makeStyles((theme: any) => ({
    section: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
    },
    heading: sectionHeading(theme),
    grid: {
        display: 'grid',
        gap: '2rem',
        alignItems: 'stretch',
        gridTemplateColumns: `repeat(auto-fit, minmax(${MIN_CARD_WIDTH}, 1fr))`,
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
            gap: '1rem',
            alignItems: 'start',
        },
    },
    seeAll: {
        alignSelf: 'center',
        fontSize: '0.875rem',
        fontWeight: theme.weight.body,
        color: theme.palette.common.darkGrey,
        textDecoration: 'underline',
        textDecorationColor: theme.palette.common.yellow,
        textDecorationThickness: 2,
        textUnderlineOffset: '0.2em',
        '&:hover, &:focus-visible': {
            textDecorationThickness: 3,
        },
    },
}));

export const UpcomingAppointments = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { upcoming, isLoading } = usePatientAppointments();

    const visible = upcoming.slice(0, MAX_CARDS);

    if (isLoading || visible.length === 0) return null;

    return (
        <section className={classes.section}>
            <Typography className={classes.heading}>{t('UpcomingAppointmentsHeading')}</Typography>

            <div className={classes.grid}>
                {visible.map((appointment) => (
                    <AppointmentSummaryCard
                        key={appointment.id}
                        appointment={appointment}
                        wide={visible.length === 1}
                    />
                ))}
            </div>

            {upcoming.length > MAX_CARDS && (
                <Link to="/appointments" className={classes.seeAll}>
                    {t('SeeAllAppointments')}
                </Link>
            )}
        </section>
    );
};
